export const DEFAULT_TEXTS = {
  title: 'Historiske priser',
  metalLabel: 'Metall',
  metalGold: 'Gull',
  metalSilver: 'Sølv',
  metalPalladium: 'Palladium',
  metalPlatinum: 'Platina',
  unitLabel: 'Enhet',
  unitOunce: 'Unser',
  unitGram: 'Gram',
  unitKg: 'KG',
  currencyLabel: 'Valuta',
  dateLabel: 'Dato',
  timeSpan1d: '1d',
  timeSpan1w: '1u',
  timeSpan1m: '1m',
  timeSpan3m: '3m',
  timeSpan6m: '6m',
  timeSpanYtd: 'i år',
  timeSpan1y: '1 år',
  timeSpan3y: '3 år',
  timeSpan5y: '5 år',
  timeSpan10y: '10 år',
  timeSpanMax: 'Maks',
  sliderLabel: 'Dra for å zoome eller endre tidsvindu',
  keyFiguresTitle: 'Nøkkeltall',
  keyFiguresLatest: 'Siste',
  keyFiguresHighest: 'Høyeste (siste 12 mnd)',
  keyFiguresLowest: 'Laveste (siste 12 mnd)',
  comparisonTitle: 'Sammenligning',
  loadingText: 'Henter historiske priser. Vennligst vent...',
  errorText: 'En feil oppsto i uthenting av priser. Prøv igjen.',
  noDataText: 'Ingen data tilgjengelig for valgt periode.',
  // Mobile texts
  filterButton: 'Filter',
  saveButton: 'Lagre',
  backButton: 'Tilbake',
  intervalChangeLabel: 'Endringer (i valgt intervall)',
  granularityDay: 'Dag',
  granularityWeek: 'Uke',
  granularityMonth: 'Måned'
}

export const TIME_SPAN_OFFSETS = {
  '1d':  d => d.setDate(d.getDate() - 1),
  '1w':  d => d.setDate(d.getDate() - 7),
  '1m':  d => d.setMonth(d.getMonth() - 1),
  '3m':  d => d.setMonth(d.getMonth() - 3),
  '6m':  d => d.setMonth(d.getMonth() - 6),
  'ytd': d => { d.setMonth(0); d.setDate(1) },
  '1y':  d => d.setFullYear(d.getFullYear() - 1),
  '3y':  d => d.setFullYear(d.getFullYear() - 3),
  '5y':  d => d.setFullYear(d.getFullYear() - 5),
  '10y': d => d.setFullYear(d.getFullYear() - 10),
  'max': d => { d.setFullYear(1950); d.setMonth(0); d.setDate(1) }
}

export const METAL_COLORS = {
  AU: { border: '#C9A84C', bg: 'rgba(201, 168, 76, 0.15)', bgStops: ['rgba(201, 168, 76, 0.35)', 'rgba(201, 168, 76, 0.02)'] },
  AG: { border: '#8B9DAF', bg: 'rgba(139, 157, 175, 0.15)', bgStops: ['rgba(139, 157, 175, 0.35)', 'rgba(139, 157, 175, 0.02)'] },
  PD: { border: '#7B9E6B', bg: 'rgba(123, 158, 107, 0.15)', bgStops: ['rgba(123, 158, 107, 0.35)', 'rgba(123, 158, 107, 0.02)'] },
  PT: { border: '#9B8EC4', bg: 'rgba(155, 142, 196, 0.15)', bgStops: ['rgba(155, 142, 196, 0.35)', 'rgba(155, 142, 196, 0.02)'] }
}

export const MOBILE_TIME_SPAN_KEYS = ['1d', '1w', '1m', '3m', '6m', '1y']
